module.exports = __webpack_public_path__ + "img/cash.bc649c06.svg";